<div
	class="card"
	*ngIf="
		isListingAudit(listingHistories) ? listingHistories : listingHistories[0] as listingHistory
	"
	[class.disabled-card]="listingHistory?.deleteDTTM"
>
	<div class="card-header">
		<div class="row w-100 align-items-center ml-0">
			<div class="col-12 col-md-5 text-start mb-2 mb-md-0">
				<span
					[nstarReference]="listingHistory.modificationUserName"
					[ngbTooltip]="listingHistory?.memberFullName"
					container="body"
					type="member"
					[disabled]="true"
				>
					{{ listingHistory.modificationUserName }}
				</span>
			</div>

			<div class="col-12 col-md-2 text-center mb-2 mb-md-0" *ngIf="!listingHistory?.deleteDTTM">
				<button
					class="btn btn-sm"
					[class.btn-primary]="!showDifference"
					[class.btn-secondary]="showDifference"
					(click)="showDifference = !showDifference"
				>
					{{ showDifference ? "Hide" : "Show" }} Differences
				</button>
			</div>
			<div
				*ngIf="listingHistory?.deleteDTTM"
				style="flex: 1"
				class="col-12 col-md-2 text-center small text-danger mb-2 mb-md-0"
			>
				{{ listingHistory.deleteDTTM | date : "short" }}
			</div>
			<div class="col-12 col-md-5 text-end d-flex justify-content-end align-items-center">
				<small class="text-muted me-2">
					{{ listingHistory.modificationTimestampUTCDTTM + "Z" | date : "short" }}</small
				>
				<button
					*ngIf="modifyListingAudit && !listingHistory?.deleteDTTM"
					ngbTooltip="Delete"
					(click)="deleteListingHistory(listingHistory)"
					class="btn btn-sm btn-delete"
				>
					<i nstarIcon>delete</i>
				</button>
				<span
					*ngIf="!modifyListingAudit || !!listingHistory?.deleteDTTM"
					class="btn btn-sm invisible btn-delete"
					><i nstarIcon>delete</i></span
				>
			</div>
		</div>
	</div>
	<div class="card-body text-center">
		<ng-container *ngIf="isListingAudit(listingHistories); else modificationLogTemplate">
			<app-history-item
				[historyData]="listingHistories"
				[showDifference]="showDifference"
			></app-history-item>
		</ng-container>
		<ng-template #modificationLogTemplate>
			<app-history-item
				*ngFor="let history of listingHistories"
				[historyData]="history"
				[showDifference]="showDifference"
			></app-history-item>
		</ng-template>
	</div>
</div>
